export const LocationDetailConstants = {
    GET_LOC_DETAIL: 'GET_LOC_DETAIL',

    GETALL_LOC_DETAIL_REQUEST: 'GETALL_LOC_DETAIL_REQUEST',
    GETALL_LOC_DETAIL_SUCCESS: 'GETALL_LOC_DETAIL_SUCCESS',
    GETALL_LOC_DETAIL_FAILURE: 'GETALL_LOC_DETAIL_FAILURE'
};